/**
 * @file News Downloads
 */

import { gsap } from 'gsap';
import ScrollTrigger from 'gsap/ScrollTrigger';

/**
 * News Downloads component
 */
const vNewsDownloads = () => {
	const newsDownloads = document.querySelector( '.v-news-downloads' );

	if ( ! newsDownloads ) {
		return;
	}

	gsap.registerPlugin( ScrollTrigger );

	const news          = newsDownloads.querySelector( '.v-news-downloads__news-inner' );
	const downloads     = newsDownloads.querySelector( '.v-news-downloads__downloads-inner' );
	const gsapTo        = { opacity: 1, ease: 'power1.inOut', duration: 1 };
	const gsapFrom      = { opacity: 0 };
	const toggleActions = 'play none none reset';
	const start         = 'top bottom-=10%';

	if ( news ) {
		const newsTriggerVars      = {
			trigger: news,
			toggleActions,
		};

		gsap.fromTo( news, gsapFrom, {
			...gsapTo,
			scrollTrigger: {
				start,
				...newsTriggerVars,
			},
		} );
	}

	if ( downloads ) {
		const downloadsTriggerVars = {
			trigger: downloads,
			toggleActions,
		};

		gsap.fromTo( downloads, gsapFrom, {
			...gsapTo,
			scrollTrigger: {
				start,
				...downloadsTriggerVars,
			},
		} );
	}
};

export default vNewsDownloads;
